import React, {Component} from 'react'
import {FormattedMessage} from 'react-intl'

class CalendarStatusBadge extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            status: this.props.status || '',
            style: this.props.style || {},
        }
        this.className = this.props.className || ''
    }
    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            status: nextProps.status || '',
            style: nextProps.style || {},
        })
    }

    renderStatus() {
        switch (this.state.status) {
            case 'active':
                return <div className="badge badge-success text-with-icon">
                    <FormattedMessage
                        id="calendar.status.active_label"
                        defaultMessage="Active"
                    />
                </div>
            case 'inactive':
                return <div className="badge badge-secondary text-with-icon">
                    <FormattedMessage
                        id="calendar.status.inactive_label"
                        defaultMessage="Inactive"
                    />
                </div>
        }
        return <div />
    }

    render() {
        return <span className={this.className} style={this.state.style}>
            {this.renderStatus()}
        </span>
    }

}

export default CalendarStatusBadge





// WEBPACK FOOTER //
// ./src/calendar/status.component.jsx